export const TOPUP_CONFIG = {
  topupAmounts: [50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600],
  topupAmountMin: 0.01,
  topupAmountMax: 1000
}

export const TOPUP_AREA_MAX = 100
export const TOPUP_FIRST_AREA = 50
export const TOPUP_SECOND_AREA = TOPUP_AREA_MAX - TOPUP_FIRST_AREA
